import { userinfo } from './../../Services/userinfo';
import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { AddNewPolicyMdl } from '../../Models/AddNewPolicy';
import { InsuredMdl } from '../../Models/InsuredMdl';
import Swal from 'sweetalert2';

@Component({
  selector: 'Welcome',
  templateUrl: './Welcome.html',
  styleUrls: ['./Welcome.css']
})
export class Welcome {
  public AddNewPolicyObj: AddNewPolicyMdl = new AddNewPolicyMdl();
  public RegObj: InsuredMdl = new InsuredMdl();
  public License: boolean;
  public OTP: boolean;
  public Vehicle: boolean;
  public Count: number = 1;
  public Motor: boolean;
  public SelectedType: string;
  public PolicyTrue: boolean;
  public DobRequired: boolean;
  public HasOtp: boolean;
  public BtnText: string;

  public InsuredName: string;
  constructor(private router: Router, private usrinfo: userinfo) {
    this.AddNewPolicyObj.PolicyType = "5515";
    sessionStorage.setItem("IsMedMalEdit", "N");

    if (sessionStorage.getItem("InsuredName") != null) {
      this.usrinfo.setUserInfo(sessionStorage.getItem("InsuredName"));

    }
    sessionStorage.setItem("IsTravelEdit", "N");


    

    this.BtnText = "Proceed";
  }

  GetOtp() {
    this.HasOtp = true;
  }

  ValidateIqama(evt: any) {
    if (this.RegObj.IqamaNo.length > 0) {
      if (evt.target.value.charAt(0) == "1") {
        this.DobRequired = true;
      }
      else {
        this.DobRequired = false;
      }
    }
    else {
      Swal("Please enter Iqama No")
    }

  }

  Next() {
    this.Count++;
    if (this.Count == 2) {
      this.OTP = true;
      this.License = false;
      this.BtnText = "Verify"
    }
    else if (this.Count == 3) {
      this.OTP = false;
      this.router.navigate(['./PolicyDashboard/Policy']);
    }


  }

  checked(Event: any) {
    if (Event.target.checked) {
      this.AddNewPolicyObj.Transfer = true;
    }
    else {
      this.AddNewPolicyObj.Transfer = false;
    }
  }
  Back() {
    this.Motor = false;
  }

  Proceed() {

  }
  Motors() {
    this.Motor = true;
    this.SelectedType = "Motor TPL";
  }
  Comprehensive() {
    this.Motor = true;
    this.SelectedType = "Motor Comprehensive";
  }
  Medical() {
    this.Motor = true;
    this.SelectedType = "Medical Insurance";
  }

  Dashboard() {
    this.router.navigate(['./Master/PolicyDashboard']);
  }

  Travel() {
    window.open('https://lbc.ggi-sa.com/TravelLive/#/Landing', "_blank")
  }

  CommingSoon(){
    Swal("Comming Soon...","","info")
  }
}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Welcome/Welcome.ts